import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  .MuiTypography-root {\n    padding: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  padding-bottom: 82px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  overflow-y: auto;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 16px 28px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        ""
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { calculateDiscountAmount } from "@/components/Checkout/index";
import { Radio } from "@/components/common/AntdRadio";
import { ScrollBody } from "@/components/Coupons/AdditionalCouponContents";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { numberFormatter } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { styled as muiStyled, Typography } from "@mui/material";
import dayjs from "dayjs";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import styled, { useTheme } from "styled-components";
import FilledButton from "../common/Button/FilledButton";
import SimpleDialog from "../Coupons/SimpleDialog";
import AnchorDrawer from "../modal/AnchorDrawer";
export const ApplyCouponModal = (param)=>{
    let { isOpen , onClose , couponList , item , showSnackbar , applyCoupon  } = param;
    const { isMobile  } = useWindowDimensions();
    if (!isMobile) return /*#__PURE__*/ _jsx(SimpleDialog, {
        open: isOpen,
        onClose: onClose,
        title: "적용가능한 쿠폰",
        subParagraph: "해당 상품에 적용가능한 쿠폰만 표시돼요.",
        scroll: "paper",
        children: /*#__PURE__*/ _jsx(DialogContents, {
            children: /*#__PURE__*/ _jsx(ApplyCoupon, {
                onCancel: onClose,
                couponList: couponList,
                item: item,
                showSnackbar: showSnackbar,
                applyCoupon: applyCoupon
            })
        })
    });
    return /*#__PURE__*/ _jsx(AnchorDrawer, {
        anchor: "bottom",
        open: isOpen,
        onClose: onClose,
        title: "할인쿠폰 받기",
        children: /*#__PURE__*/ _jsxs(AnchorDrawer.Contents, {
            children: [
                /*#__PURE__*/ _jsx(AnchorDrawer.Title, {
                    children: "적용가능한 쿠폰"
                }),
                /*#__PURE__*/ _jsx(AnchorSubTitle, {
                    children: "해당 상품에 적용가능한 쿠폰만 표시돼요."
                }),
                /*#__PURE__*/ _jsx(ScrollBody, {
                    children: /*#__PURE__*/ _jsx(ApplyCoupon, {
                        onCancel: onClose,
                        couponList: couponList,
                        item: item,
                        showSnackbar: showSnackbar,
                        applyCoupon: applyCoupon
                    })
                })
            ]
        })
    });
};
const ApplyCoupon = (param)=>{
    let { onCancel , couponList , item , showSnackbar , applyCoupon  } = param;
    const [radioValue, setRadioValue] = useState(item.appliedCouponId || "none");
    const onChangeRadio = useCallback((e)=>{
        setRadioValue(e.target.value);
    }, [
        item,
        couponList
    ]);
    const radioOptions = useMemo(()=>{
        return [
            {
                label: "쿠폰 적용안함",
                value: "none"
            },
            ...couponList.map((coupon)=>({
                    label: /*#__PURE__*/ _jsx(CouponItem, {
                        discountAmount: calculateDiscountAmount({
                            discountType: coupon.discountType,
                            discountValue: coupon.discountValue,
                            price: item.price,
                            discountMaximumPrice: coupon.discountMaximumPrice
                        }),
                        couponTitle: coupon.name,
                        expiredAt: coupon.expiredAt,
                        maximumAmount: coupon.discountMaximumPrice,
                        minimumPrice: coupon.minimumPrice
                    }),
                    value: coupon.id
                }))
        ];
    }, [
        item,
        couponList
    ]);
    useEffect(()=>{
        setRadioValue(item.appliedCouponId || "none");
    }, [
        item
    ]);
    return /*#__PURE__*/ _jsxs(ApplyCouponContainer, {
        children: [
            /*#__PURE__*/ _jsx(RadioContainer, {
                children: /*#__PURE__*/ _jsx(Radio, {
                    radioOptions: radioOptions,
                    value: radioValue,
                    onChange: onChangeRadio
                })
            }),
            /*#__PURE__*/ _jsxs(ModalFooter, {
                children: [
                    /*#__PURE__*/ _jsx(ConfirmButton, {
                        type: "text",
                        variant: "soft",
                        onClick: ()=>{
                            onCancel();
                            mixpanelEvent("Popup Button Clicked", {
                                "Popup Type": "Coupon Change",
                                "Popup Title": "적용가능한 쿠폰",
                                "Button Name": "닫기",
                                "Button Url": null
                            });
                        },
                        children: "닫기"
                    }),
                    /*#__PURE__*/ _jsx(ConfirmButton, {
                        type: "text",
                        variant: "solid",
                        onClick: ()=>{
                            const selectedCoupon = couponList.find((coupon)=>coupon.id === radioValue);
                            applyCoupon(item, selectedCoupon ? selectedCoupon : null);
                            onCancel();
                            showSnackbar();
                            mixpanelEvent("Popup Button Clicked", {
                                "Popup Type": "Coupon Change",
                                "Popup Title": "적용가능한 쿠폰",
                                "Button Name": "적용하기",
                                "Button Url": null
                            });
                        },
                        children: "적용하기"
                    })
                ]
            })
        ]
    });
};
const CouponItem = (param)=>{
    let { discountAmount , couponTitle , expiredAt , maximumAmount , minimumPrice  } = param;
    const theme = useTheme();
    return /*#__PURE__*/ _jsxs(CouponItemContainer, {
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                variant: "semibold16",
                color: theme.new.colors.sol_red_400,
                children: [
                    "적용시 ",
                    numberFormatter(discountAmount),
                    "원 할인"
                ]
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "semibold14",
                color: theme.new.colors.sol_gray_700,
                children: couponTitle
            }),
            maximumAmount > 0 && /*#__PURE__*/ _jsxs(Typography, {
                variant: "regular14",
                color: theme.new.colors.sol_gray_500,
                children: [
                    "최대 ",
                    numberFormatter(maximumAmount),
                    "원 할인"
                ]
            }),
            minimumPrice > 0 && /*#__PURE__*/ _jsxs(Typography, {
                variant: "regular14",
                color: theme.new.colors.sol_gray_500,
                children: [
                    "쿠폰 사용 상품 금액: ",
                    numberFormatter(minimumPrice),
                    "원 이상"
                ]
            }),
            /*#__PURE__*/ _jsxs(Typography, {
                variant: "regular14",
                color: theme.new.colors.sol_gray_300,
                children: [
                    dayjs(expiredAt).format("YYYY.MM.DD"),
                    "까지"
                ]
            })
        ]
    });
};
const CouponItemContainer = styled.div.withConfig({
    componentId: "sc-c710d113-0"
})(_templateObject());
const ApplyCouponContainer = styled.div.withConfig({
    componentId: "sc-c710d113-1"
})(_templateObject1());
const AnchorSubTitle = muiStyled("p")((param)=>{
    let { theme  } = param;
    return {
        marginBottom: 16,
        color: theme.palette.grey[700],
        ...theme.typography.regular16
    };
});
const RadioContainer = styled.div.withConfig({
    componentId: "sc-c710d113-2"
})(_templateObject2());
const ModalFooter = styled.div.withConfig({
    componentId: "sc-c710d113-3"
})(_templateObject3(), (props)=>props.theme.new.colors.sol_dim_white_90);
const ConfirmButton = muiStyled(FilledButton)((param)=>{
    let { theme  } = param;
    return {
        padding: "12px 20px",
        ...theme.typography.semibold16,
        [theme.breakpoints.down("sm")]: {
            width: "100%"
        }
    };
});
const DialogContents = styled.div.withConfig({
    componentId: "sc-c710d113-4"
})(_templateObject4());
